"use strict";

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});

function clone(originalObject) {
  if (!originalObject) {
    return null;
  }

  return JSON.parse(JSON.stringify(originalObject));
}

exports.clone = clone;